<!-- src/components/User/AccessDeniedModal.vue -->
<script setup>
import { useUserStore } from "@/stores/useUserStore";

defineProps({
  show: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(["close"]);

const userStore = useUserStore();
</script>

<template>
  <Teleport to="body">
    <div v-if="show" class="access-denied-backdrop">
      <div class="access-denied-panel">
        <div class="access-denied-icon">🔒</div>
        <h3 class="access-denied-title">Acesso restrito</h3>
        <p class="access-denied-body">
          Você está operando como membro de
          <strong>{{ userStore.currentUser?.managerName }}</strong>.
          Apenas o titular da conta pode visualizar e alterar o plano.
        </p>
        <button class="access-denied-btn" @click="emit('close')">
          Entendido
        </button>
      </div>
    </div>
  </Teleport>
</template>

<style scoped>
.access-denied-backdrop {
  position: fixed;
  inset: 0;
  z-index: 20000;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 8vh 1rem 1rem;
}

.access-denied-panel {
  background: var(--surface);
  border-radius: 14px;
  padding: 2rem 1.75rem;
  max-width: 360px;
  width: 100%;
  text-align: center;
  box-shadow: var(--shadow-modal-lg);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
}

.access-denied-icon {
  font-size: 2.5rem;
  line-height: 1;
}

.access-denied-title {
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-dark);
  margin: 0;
}

.access-denied-body {
  font-size: 0.85rem;
  color: var(--text-muted);
  line-height: 1.55;
  margin: 0;
}

.access-denied-body strong {
  color: var(--text-dark);
  font-weight: 600;
}

.access-denied-btn {
  margin-top: 0.5rem;
  width: 100%;
  padding: 0.55rem 1rem;
  border-radius: 10px;
  border: none;
  background: var(--brand-light);
  color: var(--text-on-brand);
  font-size: 0.88rem;
  font-weight: 700;
  cursor: pointer;
  transition: filter 0.2s;
}

.access-denied-btn:hover {
  filter: brightness(0.93);
}
</style>